import { ranking } from "@/mocks/home";
import Reveal from "./Reveal";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-primary-600",
  down: "ri-arrow-down-line text-secondary-500",
  flat: "ri-subtract-line text-foreground-400",
};

const trendText: Record<string, string> = {
  up: "热度上升",
  down: "热度回落",
  flat: "基本持平",
};

export default function Ranking() {
  return (
    <section id="ranking" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-4">
            <span className="text-xs tracking-[0.3em] text-secondary-500 uppercase">Ranking</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              补课热榜
            </h2>
            <p className="mt-3 text-sm md:text-base leading-7 text-foreground-700">
              最近被翻出来补课最多的旧瓜复盘，按查看热度排序，不知道从哪条开始就先看榜单。
            </p>
            <a
              href="#discussion"
              className="mt-6 inline-flex items-center gap-2 h-10 px-4 rounded-md bg-secondary-500 text-background-50 text-sm font-medium hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              看看大家在聊什么
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="bg-background-100 border border-background-200 rounded-lg divide-y divide-background-200">
              {ranking.map((item, index) => (
                <Reveal key={item.rank} delay={index * 50} className="">
                  <a
                    href="#ranking"
                    className="flex items-center gap-4 px-4 md:px-6 py-4 hover:bg-background-50 transition-colors cursor-pointer"
                  >
                    <span
                      className={`w-8 h-8 shrink-0 rounded-md flex items-center justify-center font-heading text-sm font-bold ${
                        item.rank <= 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-sm md:text-base font-medium text-foreground-950 truncate">
                        {item.title}
                      </h3>
                      <div className="mt-1 flex items-center gap-3 text-[11px] text-foreground-500">
                        <span className="inline-flex items-center gap-1 whitespace-nowrap">
                          <i className="ri-price-tag-3-line" />
                          {item.tag}
                        </span>
                        <span className="inline-flex items-center gap-1 whitespace-nowrap">
                          <i className={trendIcon[item.trend]} />
                          {trendText[item.trend]}
                        </span>
                      </div>
                    </div>
                    <div className="text-right shrink-0">
                      <span className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                        {item.heat}
                      </span>
                      <span className="block text-[11px] text-foreground-500">查看热度</span>
                    </div>
                  </a>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}